// extracted by mini-css-extract-plugin
export default {"btn":"styles-scoped__btn--Mupbs"};